import { createGate } from "effector-react";
import { createEffect, createEvent, createStore, sample } from "effector";
import { persist } from "effector-storage/session";

import { setToken, get } from "src/shared/api";
import { history } from "src/shared/library/router";

export const UserGate = createGate("user gate");
export const logout = createEvent();

export const $user = createStore<Record<string, any>>({});

const fetchProfileFx = createEffect(async () => {
  const response = await get("auth/profile/");
  return await response.data;
});

const $token = createStore("").reset(logout);

const redirectAndReloadFx = createEffect((path: string) => {
  history.push(path);
  window.sessionStorage.clear();
  window.location.reload();
});

sample({
  clock: logout,
  fn: () => "/",
  target: redirectAndReloadFx,
});

const setTokenHeader = createEvent<string>("set token in header");

persist({
  key: "token",
  store: $token,
});

export const $isLoggedIn = $token.map((token) =>
  token?.length > 0 ? token !== "{{ token }}" : false
);

sample({
  clock: [$isLoggedIn, UserGate.open],
  source: $token,
  filter: (token) => (token?.length > 0 ? token !== "{{ token }}" : false),
  target: [setTokenHeader, fetchProfileFx],
});

setTokenHeader.watch((token) => {
  setToken(token);
});

sample({
  clock: fetchProfileFx.doneData,
  target: $user,
});
